webpackJsonp([13,11],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(30);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(340);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(395);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(47);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueI18n = __webpack_require__(338);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	__webpack_require__(286);
	
	var _elementUi = __webpack_require__(45);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(285);
	
	var _vueLazyload = __webpack_require__(339);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	var _en = __webpack_require__(272);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _zhCN = __webpack_require__(102);
	
	var _zhCN2 = _interopRequireDefault(_zhCN);
	
	var _th = __webpack_require__(273);
	
	var _th2 = _interopRequireDefault(_th);
	
	var _zhTW = __webpack_require__(275);
	
	var _zhTW2 = _interopRequireDefault(_zhTW);
	
	var _vi = __webpack_require__(274);
	
	var _vi2 = _interopRequireDefault(_vi);
	
	var _all = __webpack_require__(180);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _routes = __webpack_require__(187);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(188);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vueLazyload2.default);
	
	_vue2.default.config.lang = 'zh-CN';
	
	var zhCnLocales = {};
	var enUsLocales = {};
	var thThLocales = {};
	var zhTwLocales = {};
	var viTwLocales = {};
	(0, _keys2.default)(_all2.default).forEach(function (langKey) {
	    zhCnLocales[langKey] = _all2.default[langKey]['zh-CN'];
	    enUsLocales[langKey] = _all2.default[langKey]['en-US'];
	    thThLocales[langKey] = _all2.default[langKey]['th-TH'];
	    zhTwLocales[langKey] = _all2.default[langKey]['zh-TW'];
	    viTwLocales[langKey] = _all2.default[langKey]['vi-VN'];
	});
	
	_vue2.default.locale('zh-CN', (0, _assign2.default)(zhCnLocales, _zhCN2.default));
	_vue2.default.locale('en-US', (0, _assign2.default)(enUsLocales, _en2.default));
	_vue2.default.locale('th-TH', (0, _assign2.default)(thThLocales, _th2.default));
	_vue2.default.locale('zh-TW', (0, _assign2.default)(zhTwLocales, _zhTW2.default));
	_vue2.default.locale('vi-VN', (0, _assign2.default)(viTwLocales, _vi2.default));
	
	var router = new _vueRouter2.default({
	    mode: 'history',
	    routes: _routes2.default,
	    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	        return { x: 0, y: 0 };
	    }
	});
	
	router.beforeEach(function (_ref, from, next) {
	    var meta = _ref.meta,
	        path = _ref.path;
	
	    _store2.default.commit('setLoginPath', '');
	    var _meta$auth = meta.auth,
	        auth = _meta$auth === undefined ? true : _meta$auth;
	
	    var isLogin = Boolean(_store2.default.state.user.accessToken);
	    if (auth && !isLogin) {
	        _store2.default.commit('setLoginPath', path);
	        return _store2.default.commit('controlLoginPopup', true);
	    }
	    next();
	});
	
	_vue2.default.http.options.root = ("/api");
	
	_vue2.default.use(_vueLazyload2.default, {
	    preLoad: 1.3,
	    loading: 'static/img/partial/loading.svg',
	    attempt: 1
	});
	
	var vm = new _vue2.default({
	    el: '#app',
	    template: '<App/>',
	    components: { App: _App2.default },
	    router: router,
	    store: _store2.default
	});

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_LOGIN = exports.USER_LOGIN = 'USER_LOGIN';
	var USER_LOGOUT = exports.USER_LOGOUT = 'USER_LOGOUT';
	var USER_REGISTER = exports.USER_REGISTER = 'USER_REGISTER';
	
	var GET_RECORDS = exports.GET_RECORDS = 'GET_RECORDS';
	var SET_RECORDS = exports.SET_RECORDS = 'SET_RECORDS';
	
	var GET_APP_LIST = exports.GET_APP_LIST = 'GET_APP_LIST';
	var SET_APP_LIST = exports.SET_APP_LIST = 'SET_APP_LIST';
	var GET_GOODS_LIST = exports.GET_GOODS_LIST = 'GET_GOODS_LIST';
	var SET_GOODS_LIST = exports.SET_GOODS_LIST = 'SET_GOODS_LIST';
	var GET_USER_PLAYED_GAME = exports.GET_USER_PLAYED_GAME = 'GET_USER_PLAYED_GAME';
	var SET_USER_PLAYED_GAME = exports.SET_USER_PLAYED_GAME = 'SET_USER_PLAYED_GAME';
	var GET_SERVER_LIST = exports.GET_SERVER_LIST = 'GET_SERVER_LIST';
	var SET_SERVER_LIST = exports.SET_SERVER_LIST = 'SET_SERVER_LIST';
	var GET_ROLE_INFO = exports.GET_ROLE_INFO = 'GET_ROLE_INFO';
	var EG_BUY_GOODS = exports.EG_BUY_GOODS = 'EG_BUY_GOODS';

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(84);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enjoyUrl = 'https://egplatform.enjoygame.com:7093/';
	
	var isTest = false;
	exports.default = {
	    enjoyUrl: enjoyUrl,
	    isTest: isTest,
	    methods: {
	        setStorageItem: function setStorageItem(key, value) {
	            if (value instanceof Object) {
	                value = (0, _stringify2.default)(value);
	            }
	            localStorage.setItem(key, value);
	            var timeStamp = Date.parse(new Date()) / 1000;
	            var jsonObj = { 'time': timeStamp, 'ttl': 600 };
	            localStorage.setItem(key + '_time', (0, _stringify2.default)(jsonObj));
	        },
	        getStorageItem: function getStorageItem(key) {
	            var str = localStorage.getItem(key + '_time');
	            if (str) {
	                var obj = JSON.parse(str);
	                var curTime = Date.parse(new Date()) / 1000;
	                if (Math.abs(curTime - obj.time) >= obj.ttl) {
	                    localStorage.removeItem(key + '_time');
	                    localStorage.removeItem(key);
	                    return false;
	                } else {
	                    return localStorage.getItem(key);
	                }
	            }
	            localStorage.removeItem(key + '_time');
	            localStorage.removeItem(key);
	            return false;
	        }
	    }
	};

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(47);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _blueimpMd = __webpack_require__(17);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	exports.default = {
	    login: function login(user, success_callback, fail_callback) {
	        _vue2.default.http.post('user/login', {
	            account: user.account,
	            password: user.password
	        }).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = parseInt(apiResult.code);
	            if (apiCode === 0) {
	                success_callback(apiResult.result.loginData);
	                window.location.reload();
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    register: function register(user, success_callback, fail_callback) {
	        _vue2.default.http.post('user/create', {
	            account: user.account,
	            password: user.password
	        }).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = parseInt(apiResult.code);
	            if (apiCode === 0) {
	                success_callback(apiResult.result.loginData);
	                window.location.reload();
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getEg: function getEg(uid, callback) {
	        _vue2.default.http.get('store/get_eg?uid=' + uid).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                callback(apiResult.result.egPoint);
	            }
	        });
	    }
	};

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Header = __webpack_require__(356);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(355);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'app',
	    components: {
	        ViewHeader: _Header2.default, ViewFooter: _Footer2.default
	    },
	    mounted: function mounted() {}
	};

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _global = __webpack_require__(22);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cuLang = void 0;
	if (localStorage.getItem('cuLang')) {
	    cuLang = localStorage.getItem('cuLang');
	} else {
	    cuLang = navigator.language;
	    localStorage.setItem('cuLang', cuLang);
	}
	var locLang = 'English';
	if (cuLang === 'zh-CN') {
	    locLang = '简体中文';
	} else if (cuLang === 'th-TH') {
	    locLang = 'ภาษาไทย';
	} else if (cuLang === 'zh-TW') {
	    locLang = '繁體中文';
	} else if (cuLang === 'vi-VN') {
	    locLang = 'Tiếng việt';
	}
	exports.default = {
	    data: function data() {
	        return {
	            options: [{
	                value: 'zh-CN',
	                label: '简体中文'
	            }, {
	                value: 'en-US',
	                label: 'English'
	            }, {
	                value: 'th-TH',
	                label: 'ภาษาไทย'
	            }, {
	                value: 'zh-TW',
	                label: '繁體中文'
	            }, {
	                value: 'vi-VN',
	                label: 'Tiếng việt'
	            }],
	            value4: locLang,
	            global: _global2.default
	        };
	    },
	
	    computed: {
	        currentLang: function currentLang() {
	            return _vue2.default.config.lang;
	        }
	    },
	    methods: {
	        changeLang: function changeLang(lang) {
	            _vue2.default.config.lang = lang;
	
	            localStorage.setItem('cuLang', lang);
	        },
	        clearCache: function clearCache() {
	            localStorage.removeItem('carouselData');
	            localStorage.removeItem('carouselData_time');
	
	            localStorage.removeItem('nearNewsData');
	            localStorage.removeItem('nearNewsData_time');
	
	            localStorage.removeItem('hotGameData');
	            localStorage.removeItem('hotGameData_time');
	
	            localStorage.removeItem('gameCenterData');
	            localStorage.removeItem('gameCenterData_time');
	
	            localStorage.removeItem('newsData');
	            localStorage.removeItem('newsData_time');
	        }
	    }
	};

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(47);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _blueimpMd = __webpack_require__(17);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	function getBrowser() {
	    var ua = navigator.userAgent,
	        tem = void 0,
	        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	    if (/trident/i.test(M[1])) {
	        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
	        return { name: 'IE', version: tem[1] || '' };
	    }
	    if (M[1] === 'Chrome') {
	        tem = ua.match(/\bOPR|Edge\/(\d+)/);
	        if (tem != null) {
	            return { name: 'Opera', version: tem[1] };
	        }
	    }
	    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
	        M.splice(1, 1, tem[1]);
	    }
	    return {
	        name: M[0],
	        version: M[1]
	    };
	}
	
	exports.default = {
	    getAppList: function getAppList(success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_app').then(function (response) {
	            var apiResult = response.data;
	            var apiCode = parseInt(apiResult.code);
	            if (apiCode === 0) {
	                success_callback(apiResult.result.appList);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getGoodsList: function getGoodsList(appId, success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_app_goods?app_id=' + appId).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                var goods = {
	                    appId: appId,
	                    goodsList: apiResult.result.goodsList
	                };
	                success_callback(goods);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getPlayedGames: function getPlayedGames(params, success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_played_app?uid=' + params.uid + '&token=' + params.accessToken).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                success_callback(apiResult.result.appList);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getServerList: function getServerList(params, success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_server?uid=' + params.uid + '&app_id=' + params.appId + '&area_id=' + params.areaId).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                success_callback(apiResult.result.server_list);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getRoleInfo: function getRoleInfo(params, success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_role?uid=' + params.uid + '&app_id=' + params.appId + '&area_id=' + params.areaId + '&server_id=' + params.serverId + '&cp_uid=' + params.cpUid + '&token=' + params.token).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                success_callback(apiResult.result.role_infos);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    egBuyGoods: function egBuyGoods(params, success_callback, fail_callback) {
	        params.browserName = getBrowser().name;
	        params.browserVersion = getBrowser().version;
	        params.password = (0, _blueimpMd2.default)(params.password);
	
	        _vue2.default.http.post('store/pay', params).then(function (response) {
	            success_callback(response.data);
	        }, function () {
	            fail_callback(-1);
	        });
	    }
	};

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(47);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	exports.default = {
	    getRecords: function getRecords(params, success_callback, fail_callback) {
	        var query = '?uid=' + params.uid + '&page=' + params.page + '&order_status=' + params.recordsStatus + '&start_date=' + params.startDate + '&end_date=' + params.endDate;
	        var apiUrl = '';
	        var records = params;
	        if (params.recordsType == 'consume') {
	            apiUrl = 'store/records' + query;
	            records.recordsType = 'consume';
	        } else {
	            apiUrl = 'recharge/records' + query;
	            records.recordsType = 'recharge';
	        }
	
	        _vue2.default.http.get(apiUrl).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = parseInt(apiResult.code);
	            if (apiCode === 0) {
	                var recordsData = [];
	                if (params.recordsType == 'consume') {
	                    recordsData = apiResult.result.consumeOrderList;
	                } else {
	                    recordsData = apiResult.result.rechargeOrderList;
	                }
	                records.data = recordsData;
	                success_callback(records);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    }
	};

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  aboutEg: {
	    'zh-CN': '关于Enjoy Game',
	    'zh-TW': '關於Enjoy Game',
	    'en-US': 'About EnjoyGame',
	    'th-TH': 'เกี่ยวกับ Enjoy Game',
	    'vi-VN': 'About EnjoyGame'
	  },
	  aboutEgP1: {
	    'zh-CN': '上海萌果信息科技有限公司（萌果游戏）成立于2012年，专注于互联网移动游戏的研发和发行。发展至今近130人，公司业务从手机游戏开始延伸至H5游戏、VR游戏、海外游戏代理发行等，旗下的EnjoyGame（英卓游戏）成立于2015年，专注致力于将中国精品手游发行到海外全球市场。团队40余人，核心成员均有8年以上海外发行经验，以专业的快速发展，以实力打造更优质精品，形成了独有的行业品牌和口碑。发行范围覆盖全球。公司致力于成为"最好的移动网络游戏制造、发行商"，将为全球的移动互联网用户提供一个更自由、更宽广、更娱乐的游戏世界！接下来萌果还将陆续推出更多不同主题、不同类型的移动互联网产品，给大家带来更优质的游戏体验！',
	    'zh-TW': 'Enjoy Game 遊戲成立於2015年，核心成員均有八年以上行業經驗，公司致力於將中國精品手機遊戲發行到海外全球市場，以專業謀求更快速發展，以實力打造更優質精品，形成了獨有的行業品牌和口碑。',
	    'en-US': 'Enjoy Game was established in 2015. The core members have more than 8 years of professional experience. The company is committed to distribute Chinese boutique mobile games to overseas markets. With several boutique products distributed, we already own a unique brand and reputation. And we are seeking for faster development with our professional ability!',
	    'th-TH': 'ค่าย Enjoy Game ก่อตั้งขึ้นในปี 2015 พนักงานหลักต่างก็มีประสบการณ์มากกว่า 8 ปี เป็นบริษัทที่ให้บริการเกมส์มือถือทั่วโลก เราใส่ใจในคุณภาพของเกมส์เป็นที่สุด จึงกลายเป็นหนึ่งในบริษัทเกมส์ที่มีชื่อเสียง',
	    'vi-VN': 'Enjoy Game was established in 2015. The core members have more than 8 years of professional experience. The company is committed to distribute Chinese boutique mobile games to overseas markets. With several boutique products distributed, we already own a unique brand and reputation. And we are seeking for faster development with our professional ability!'
	  },
	  aboutEgP2: {
	    'zh-CN': '2015年到2016年上半年,Enjoy Game主攻港澳台、东南亚市场,2016年Q2开始开拓全球多语言市场, 均取得显著成功, 所发行的《天堂战记 Lineage War》《梦幻神域》等游戏,多次被谷歌苹果推荐,均 最高取得下载TOP1-3,畅销TOP1-5 的成绩。',
	    'zh-TW': '2015年到2016年上半年，Enjoy Game主攻港澳台、東南亞市場，2016年Q2開始開拓全球多語言市場，均取得顯著成功，所發行的《Paradise War》《Sword of Fantasy》等遊戲，多次被谷歌蘋果推薦，均 最高取得下載TOP1-3，暢銷TOP1-5 的成績。',
	    'en-US': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.',
	    'th-TH': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.',
	    'vi-VN': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.'
	  },
	  brandAdvantage: {
	    'zh-CN': '品牌优势',
	    'zh-TW': '品牌優勢',
	    'en-US': 'Our Advantages',
	    'th-TH': 'Our Advantages',
	    'vi-VN': 'Our Advantages'
	  },
	  operationTitle: {
	    'zh-CN': '卓越的运营能力',
	    'zh-TW': '卓越的運營能力',
	    'en-US': 'Excellent operation capacity',
	    'th-TH': 'Excellent operation capacity',
	    'vi-VN': 'Excellent operation capacity'
	  },
	  operationItem1: {
	    'zh-CN': '产品识别能力',
	    'zh-TW': '產品識別能力',
	    'en-US': 'Product identification capability',
	    'th-TH': 'Product identification capability',
	    'vi-VN': 'Product identification capability'
	  },
	  operationItem2: {
	    'zh-CN': '产品调优能力',
	    'zh-TW': '產品調優能力',
	    'en-US': 'Product optimization capability',
	    'th-TH': 'Product optimization capability',
	    'vi-VN': 'Product optimization capability'
	  },
	  operationItem3: {
	    'zh-CN': '持续运营能力',
	    'zh-TW': '持續運營能力',
	    'en-US': 'Continuous operation capacity',
	    'th-TH': 'Continuous operation capacity',
	    'vi-VN': 'Continuous operation capacity'
	  },
	  saleTitle: {
	    'zh-CN': '领先的营销能力',
	    'zh-TW': '領先的營銷能力',
	    'en-US': 'Leading marketing capability',
	    'th-TH': 'Leading marketing capability',
	    'vi-VN': 'Leading marketing capability'
	  },
	  saleItem1: {
	    'zh-CN': '全球采量能力',
	    'zh-TW': '全球採量能力',
	    'en-US': 'Attracting global players capacity',
	    'th-TH': 'Attracting global players capacity',
	    'vi-VN': 'Attracting global players capacity'
	  },
	  saleItem2: {
	    'zh-CN': '持续优化能力',
	    'zh-TW': '持續優化能力',
	    'en-US': 'Continuous optimization capability',
	    'th-TH': 'Continuous optimization capability',
	    'vi-VN': 'Continuous optimization capability'
	  },
	  saleItem3: {
	    'zh-CN': '全面包装能力',
	    'zh-TW': '全面包裝能力',
	    'en-US': 'Global package capacity',
	    'th-TH': 'Global package capacity',
	    'vi-VN': 'Global package capacity'
	  },
	  techTitle: {
	    'zh-CN': '强大的技术支持',
	    'zh-TW': '強大的技術支持',
	    'en-US': 'Powerful technical support',
	    'th-TH': 'Powerful technical support',
	    'vi-VN': 'Powerful technical support'
	  },
	  techItem1: {
	    'zh-CN': '快速的对接流程',
	    'zh-TW': '快速的對接流程',
	    'en-US': 'Fast docking process',
	    'th-TH': 'Fast docking process',
	    'vi-VN': 'Fast docking process'
	  },
	  techItem2: {
	    'zh-CN': '强大的数据分析能力',
	    'zh-TW': '強大的數據分析能力',
	    'en-US': 'Powerful data analysis capability',
	    'th-TH': 'Powerful data analysis capability',
	    'vi-VN': 'Powerful data analysis capability'
	  },
	  techItem3: {
	    'zh-CN': '高度定制化的数据采集能力',
	    'zh-TW': '高度定制化的數據採集能力',
	    'en-US': 'Highly customizable data acquisition capability',
	    'th-TH': 'Highly customizable data acquisition capability',
	    'vi-VN': 'Highly customizable data acquisition capability'
	  },
	  history: {
	    'zh-CN': '发展历程',
	    'zh-TW': '發展歷程',
	    'en-US': 'Development',
	    'th-TH': 'กระบวนการพัฒนา',
	    'vi-VN': 'Development'
	  },
	  haveGoodGame: {
	    'zh-CN': '有好的游戏产品？',
	    'zh-TW': '有好的遊戲產品？',
	    'en-US': 'Have good game products?',
	    'th-TH': 'Have good game products?',
	    'vi-VN': 'Have good game products?'
	  },
	  gotToSubmit: {
	    'zh-CN': '前往提交',
	    'zh-TW': '前往提交',
	    'en-US': 'Go to submit',
	    'th-TH': 'Go to submit',
	    'vi-VN': 'Go to submit'
	  }
	};

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(36);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _nav = __webpack_require__(184);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _home = __webpack_require__(183);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _store = __webpack_require__(186);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _business = __webpack_require__(181);
	
	var _business2 = _interopRequireDefault(_business);
	
	var _news = __webpack_require__(185);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _games = __webpack_require__(182);
	
	var _games2 = _interopRequireDefault(_games);
	
	var _about = __webpack_require__(179);
	
	var _about2 = _interopRequireDefault(_about);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = (0, _extends3.default)({}, _nav2.default, _home2.default, _store2.default, _business2.default, _news2.default, _games2.default, _about2.default);

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  content: {
	    'zh-CN': '上海萌果信息科技有限公司（萌果游戏）成立于2012年，专注于互联网移动游戏的<br>研发和发行。发展至今近130人，公司业务从手机游戏开始延伸至H5游戏、VR游戏、海外<br>游戏代理发行等，旗下的EnjoyGame（英卓游戏）成立于2015年，专注致力于将中国精品手游发<br>行到海外全球市场。团队40余人，核心成员均有8年以上海外发行经验，以专业的快速发展，以实力打<br>造更优质精品，形成了独有的行业品牌和口碑。发行范围覆盖全球。公司致力于成为"最好的移动网络游戏制造、发行商"，将为全球的移动互联网用户提供一个更自由、更宽广、更娱乐的游戏世界！接下来萌果还将陆续推出更多不同主题、不同类型的移动互联网产品，给大家带来更优质的游戏体验！',
	    'en-US': '',
	    'th-TH': ''
	  },
	  developCooperation: {
	    'zh-CN': '研发合作',
	    'zh-TW': '',
	    'en-US': '',
	    'th-TH': ''
	  },
	  issueCooperation: {
	    'zh-CN': '发行合作',
	    'zh-TW': '',
	    'en-US': '',
	    'th-TH': ''
	  },
	  hr: {
	    'zh-CN': '求职需求',
	    'zh-TW': '',
	    'en-US': '',
	    'th-TH': ''
	  },
	  haveGoodProduction: {
	    'zh-CN': '有好的游戏产品？',
	    'zh-TW': '有好的遊戲產品？',
	    'en-US': 'Have good production?',
	    'th-TH': 'Have good production?'
	  },
	  goToSubmit: {
	    'zh-CN': '前往提交',
	    'zh-TW': '前往提交',
	    'en-US': 'Submit',
	    'th-TH': 'Submit'
	  }
	};

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  ttzj: {
	    'zh-CN': '天域战记',
	    'zh-TW': '天域戰記',
	    'en-US': 'Paradise War',
	    'th-TH': 'Paradise War'
	  },
	  mhsy: {
	    'zh-CN': '梦幻神域',
	    'zh-TW': '夢幻神域',
	    'en-US': 'Sword of Fantasy',
	    'th-TH': 'Sword of Fantasy'
	  },
	  bhmtzh: {
	    'zh-CN': '巴赫姆特之魂',
	    'zh-TW': '巴哈姆特之魂',
	    'en-US': 'Dragon Hunter',
	    'th-TH': 'Dragon Hunter'
	  },
	  jws: {
	    'zh-CN': '極無雙',
	    'zh-TW': '極無雙',
	    'en-US': 'Dynasty Legends',
	    'th-TH': 'Dynasty Legends'
	  },
	  luna: {
	    'zh-CN': 'lunaM',
	    'zh-TW': 'LunaM',
	    'en-US': 'lunaM',
	    'th-TH': 'lunaM'
	  },
	  download: {
	    'zh-CN': 'Apk下载',
	    'zh-TW': 'APK下載',
	    'en-US': 'Apk Download',
	    'th-TH': 'Apk Download'
	  }
	};

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  checkDetail: {
	    'zh-CN': '查看详情',
	    'zh-TW': '查看詳情',
	    'en-US': 'Check Detail',
	    'th-TH': 'Check Detail',
	    'vi-VN': 'Check Detail'
	  },
	  novenTitle1: {
	    'zh-CN': '銳意革新 拒絕相似！',
	    'zh-TW': '銳意革新 拒絕相似！',
	    'en-US': '銳意革新 拒絕相似！',
	    'th-TH': '銳意革新 拒絕相似！',
	    'vi-VN': '銳意革新 拒絕相似！'
	  },
	  novenTitle2: {
	    'zh-CN': '《諾文尼亞》RPG與連珠的完美結合！',
	    'zh-TW': '《諾文尼亞》RPG與連珠的完美結合！',
	    'en-US': '《諾文尼亞》RPG與連珠的完美結合！',
	    'th-TH': '《諾文尼亞》RPG與連珠的完美結合！',
	    'vi-VN': '《諾文尼亞》RPG與連珠的完美結合！'
	  },
	  novenContent: {
	    'zh-CN': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
	    'zh-TW': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
	    'en-US': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
	    'th-TH': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
	    'vi-VN': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！'
	  },
	  bhmtTitle1: {
	    'zh-CN': 'MMORPG鉅作《巴哈姆特之魂》',
	    'zh-TW': 'MMORPG鉅作《巴哈姆特之魂》',
	    'en-US': 'MMORPG鉅作《巴哈姆特之魂》',
	    'th-TH': 'MMORPG鉅作《巴哈姆特之魂》',
	    'vi-VN': 'MMORPG鉅作《巴哈姆特之魂》'
	  },
	  bhmtTitle2: {
	    'zh-CN': '火爆空降雙端榜單前列',
	    'zh-TW': '火爆空降雙端榜單前列',
	    'en-US': '火爆空降雙端榜單前列',
	    'th-TH': '火爆空降雙端榜單前列',
	    'vi-VN': '火爆空降雙端榜單前列'
	  },
	  jwsTitle1: {
	    'zh-CN': '熱血最強ARPG《極無雙》',
	    'zh-TW': '熱血最強ARPG《極無雙》',
	    'en-US': '熱血最強ARPG《極無雙》',
	    'th-TH': '熱血最強ARPG《極無雙》',
	    'vi-VN': '熱血最強ARPG《極無雙》'
	  },
	  jwsTitle2: {
	    'zh-CN': '暢爽無雙完美復刻',
	    'zh-TW': '暢爽無雙完美復刻',
	    'en-US': '暢爽無雙完美復刻',
	    'th-TH': '暢爽無雙完美復刻',
	    'vi-VN': '暢爽無雙完美復刻'
	  },
	  jwsContent: {
	    'zh-CN': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	    'zh-TW': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	    'en-US': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	    'th-TH': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	    'vi-VN': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！'
	  },
	  bhmtContent: {
	    'zh-CN': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
	    'zh-TW': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
	    'en-US': "全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！",
	    'th-TH': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
	    'vi-VN': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！'
	  },
	  appTitle1: {
	    'zh-CN': '《天域战记》全新銅像玩法',
	    'zh-TW': '《天域战记》全新銅像玩法',
	    'en-US': '《天域战记》全新銅像玩法',
	    'th-TH': '《天域战记》全新銅像玩法',
	    'vi-VN': '《天域战记》全新銅像玩法'
	  },
	  appDesc1: {
	    'zh-CN': '挑戰克隆傭兵，提升戰力！',
	    'zh-TW': '挑戰克隆傭兵，提升戰力！',
	    'en-US': '挑戰克隆傭兵，提升戰力！',
	    'th-TH': '挑戰克隆傭兵，提升戰力！',
	    'vi-VN': '挑戰克隆傭兵，提升戰力！'
	  },
	  appTitle2: {
	    'zh-CN': '《巴哈姆特之魂》震撼上线',
	    'zh-TW': '《巴哈姆特之魂》震撼上线',
	    'en-US': '《巴哈姆特之魂》震撼上线',
	    'th-TH': '《巴哈姆特之魂》震撼上线',
	    'vi-VN': '《巴哈姆特之魂》震撼上线'
	  },
	  appDesc2: {
	    'zh-CN': '即時PK、天梯排位，你能否傲視群雄？',
	    'zh-TW': '即時PK、天梯排位，你能否傲視群雄？',
	    'en-US': '即時PK、天梯排位，你能否傲視群雄？',
	    'th-TH': '即時PK、天梯排位，你能否傲視群雄？',
	    'vi-VN': '即時PK、天梯排位，你能否傲視群雄？'
	  },
	  lunaTitle1: {
	    'zh-CN': 'Q 版MMORPG神作復活！',
	    'zh-TW': 'Q 版MMORPG神作復活！',
	    'en-US': 'Q 版MMORPG神作復活！',
	    'th-TH': 'Q 版MMORPG神作復活！',
	    'vi-VN': 'Q 版MMORPG神作復活！'
	  },
	  lunaTitle2: {
	    'zh-CN': '《Luna M（首部曲）》萌動歸來！',
	    'zh-TW': '《Luna M（首部曲）》萌動歸來！',
	    'en-US': '《Luna M（首部曲）》萌動歸來！',
	    'th-TH': '《Luna M（首部曲）》萌動歸來！',
	    'vi-VN': '《Luna M（首部曲）》萌動歸來！'
	  },
	  lunaContent: {
	    'zh-CN': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	    'zh-TW': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	    'en-US': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	    'th-TH': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	    'vi-VN': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~'
	  },
	  getLiked: {
	    'zh-CN': ' 人点赞',
	    'zh-TW': ' 人点赞',
	    'en-US': ' 人点赞',
	    'th-TH': ' 人点赞',
	    'vi-VN': ' 人点赞'
	  },
	  recentNews: {
	    'zh-CN': '最新资讯',
	    'zh-TW': '最新資訊',
	    'en-US': 'Latest News',
	    'th-TH': 'Latest News',
	    'vi-VN': 'Latest News'
	  },
	  aboutCompany: {
	    'zh-CN': '公司介绍',
	    'zh-TW': '公司介紹',
	    'en-US': 'About Company',
	    'th-TH': 'About Company',
	    'vi-VN': 'About Company'
	  },
	  boutique: {
	    'zh-CN': '精品',
	    'zh-TW': '精品',
	    'en-US': 'With competitive products',
	    'th-TH': 'With competitive products',
	    'vi-VN': 'With competitive products'
	  },
	  boutiqueDesc: {
	    'zh-CN': '所发游戏多次被谷歌／ios推荐',
	    'zh-TW': '所發遊戲多次被谷歌/ios推薦',
	    'en-US': 'Our games have been featured repeatedly by Google Play and App Store',
	    'th-TH': 'Our games have been featured repeatedly by Google Play and App Store',
	    'vi-VN': 'Our games have been featured repeatedly by Google Play and App Store'
	  },
	  professional: {
	    'zh-CN': '专业',
	    'zh-TW': '專業',
	    'en-US': 'Professional',
	    'th-TH': 'Professional',
	    'vi-VN': 'Professional'
	  },
	  professionalDesc: {
	    'zh-CN': '零运营事故',
	    'zh-TW': '零運營事故',
	    'en-US': 'No operational accident',
	    'th-TH': 'No operational accident',
	    'vi-VN': 'No operational accident'
	  },
	  fast: {
	    'zh-CN': '快速',
	    'zh-TW': '快速',
	    'en-US': 'With high-speed',
	    'th-TH': 'With high-speed',
	    'vi-VN': 'With high-speed'
	  },
	  fastDesc: {
	    'zh-CN': '半年内上线全球',
	    'zh-TW': '半年內上線全球',
	    'en-US': 'Launch one game worldwide within six months',
	    'th-TH': 'Launch one game worldwide within six months',
	    'vi-VN': 'Launch one game worldwide within six months'
	  },
	  hotGames: {
	    'zh-CN': '热门游戏',
	    'zh-TW': '熱門遊戲',
	    'en-US': 'Hot Games',
	    'th-TH': 'Hot Games',
	    'vi-VN': 'Hot Games'
	  },
	  partner: {
	    'zh-CN': '合作伙伴',
	    'zh-TW': '合作夥伴',
	    'en-US': 'Partner',
	    'th-TH': 'Partner',
	    'vi-VN': 'Partner'
	  },
	  gameType: {
	    'zh-CN': '游戏类型',
	    'zh-TW': '遊戲類型',
	    'en-US': 'Type',
	    'th-TH': 'Type',
	    'vi-VN': 'Type'
	  },
	  gameRating: {
	    'zh-CN': '游戏评分',
	    'zh-TW': '遊戲評分',
	    'en-US': 'Rating',
	    'th-TH': 'Rating',
	    'vi-VN': 'Rating'
	  },
	  goToSite: {
	    'zh-CN': '进入官网',
	    'zh-TW': '進入官網',
	    'en-US': 'Official Site',
	    'th-TH': 'Official Site',
	    'vi-VN': 'Official Site'
	  },
	  changeGames: {
	    'zh-CN': '换一批',
	    'zh-TW': '換一批',
	    'en-US': 'Change Games',
	    'th-TH': 'Change Games',
	    'vi-VN': 'Change Games'
	  },
	  typeNews: {
	    'zh-CN': '新闻',
	    'zh-TW': '新聞',
	    'en-US': 'News',
	    'th-TH': 'News',
	    'vi-VN': 'News'
	  }
	};

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    eg: {
	        'zh-CN': '英卓游戏',
	        'zh-TW': '英卓遊戲',
	        'en-US': 'Enjoy Game',
	        'th-TH': 'Enjoy Game',
	        'vi-VN': 'Enjoy Game'
	    },
	    eg_mengguo: {
	        'zh-CN': '萌果游戏',
	        'zh-TW': '萌果遊戲',
	        'en-US': 'Enjoy Game',
	        'th-TH': 'Enjoy Game',
	        'vi-VN': 'Enjoy Game'
	    },
	    home: {
	        'zh-CN': '首页',
	        'zh-TW': '首頁',
	        'en-US': 'Home',
	        'th-TH': 'หน้าหลัก',
	        'vi-VN': 'Trang chủ'
	    },
	    about: {
	        'zh-CN': '关于我们',
	        'zh-TW': '關於我們',
	        'en-US': 'About Us',
	        'th-TH': 'เกี่ยวกับเรา',
	        'vi-VN': 'Giới thiệu'
	    },
	    center: {
	        'zh-CN': '游戏中心',
	        'zh-TW': '遊戲中心',
	        'en-US': 'Game Center',
	        'th-TH': 'ศูนย์เกม',
	        'vi-VN': 'Trung tâm game'
	    },
	    store: {
	        'zh-CN': '在线商城',
	        'zh-TW': '在線商城',
	        'en-US': 'Online Shop',
	        'th-TH': 'ร้านค้าออนไลน์',
	        'vi-VN': 'Shop online'
	    },
	    business: {
	        'zh-CN': '商务合作',
	        'zh-TW': '商務合作',
	        'en-US': 'Business',
	        'th-TH': 'ธุรกิจ',
	        'vi-VN': 'Thương mại'
	    },
	    news: {
	        'zh-CN': '新闻资讯',
	        'zh-TW': '新聞資訊',
	        'en-US': 'News',
	        'th-TH': 'ข่าว',
	        'vi-VN': 'Thông tin'
	    },
	    recommendGame: {
	        'zh-CN': '推荐游戏',
	        'zh-TW': '推薦遊戲',
	        'en-US': 'Recommended Games',
	        'th-TH': 'Recommended Games',
	        'vi-VN': 'Recommended Games'
	    },
	    cooperation: {
	        'zh-CN': '商务合作：',
	        'zh-TW': '商務合作：',
	        'en-US': 'Cooperation: ',
	        'th-TH': 'Cooperation',
	        'vi-VN': 'Cooperation'
	    },
	    hr: {
	        'zh-CN': '求职需求：',
	        'zh-TW': '求職需求：',
	        'en-US': 'HR: ',
	        'th-TH': 'HR: ',
	        'vi-VN': 'HR: '
	    },
	    cs: {
	        'zh-CN': '客服需求：',
	        'zh-TW': '客服需求：',
	        'en-US': 'CS: ',
	        'th-TH': 'CS: ',
	        'vi-VN': 'CS: '
	    },
	    aboutCompany: {
	        'zh-CN': '作为专业的移动手机游戏发行公司，EnjoyGame致力于将中国精品手机游戏输出和发行到海外市场。目前发行范围覆盖港澳台、东南亚、亚太、欧美等上百个国家和地区。其发行的《天域战记》、《幻想之刃》、《暗黑联盟》等多款产品在海外地区广受欢迎，多次获得谷歌和苹果的推荐，在各榜单上均有优异表现。目前Enjoygame在持续招贤纳士，并积极寻求与更多优秀的国内外产品和机构的合作。',
	        'zh-TW': '作為專業的移動手機遊戲發行公司，EnjoyGame致力於將中國精品手機遊戲輸出和發行到海外市場。目前發行範圍覆蓋港澳台、東南亞、亞太、歐美等上百個國家和地區。其發行的《天域戰記》、《幻想之刃》、《暗黑聯盟》等多款產品在海外地區廣受歡迎，多次獲得谷歌和蘋果的推薦，在各榜單上均有友誼表現。目前EnjoyGame在持續招賢納士，并積極尋求與更多優秀的國內外產品和機構的合作。',
	        'en-US': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. ',
	        'th-TH': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. ',
	        'vi-VN': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. '
	    },
	    login: {
	        'zh-CN': '登录',
	        'zh-TW': '登錄',
	        'en-US': 'Login',
	        'th-TH': 'Login',
	        'vi-VN': 'Login'
	    },
	    account: {
	        'zh-CN': '账号',
	        'zh-TW': '賬號',
	        'en-US': 'Account',
	        'th-TH': 'Account',
	        'vi-VN': 'Account'
	    },
	    accountNotEmpty: {
	        'zh-CN': '账号不能为空',
	        'zh-TW': '賬號不能為空',
	        'en-US': 'Account is needed',
	        'th-TH': 'Account is needed',
	        'vi-VN': 'Account is needed'
	    },
	    password: {
	        'zh-CN': '密码',
	        'zh-TW': '密碼',
	        'en-US': 'Password',
	        'th-TH': 'Password',
	        'vi-VN': 'Password'
	    },
	    passwordNotEmpty: {
	        'zh-CN': '密码不能为空',
	        'zh-TW': '密碼不能為空',
	        'en-US': 'Password is needed',
	        'th-TH': 'Password is needed',
	        'vi-VN': 'Password is needed'
	    },
	    captcha: {
	        'zh-CN': '验证码',
	        'zh-TW': '驗證碼',
	        'en-US': 'Captcha',
	        'th-TH': 'Captcha',
	        'vi-VN': 'Captcha'
	    },
	    captchaNotEmpty: {
	        'zh-CN': '验证码不能为空',
	        'zh-TW': '驗證碼不能為空',
	        'en-US': 'Captcha is needed',
	        'th-TH': 'Captcha is needed',
	        'vi-VN': 'Captcha is needed'
	    },
	    captchaError: {
	        'zh-CN': '验证码错误',
	        'zh-TW': '驗證碼錯誤',
	        'en-US': 'Captcha error',
	        'th-TH': 'Captcha error',
	        'vi-VN': 'Captcha error'
	    },
	    passwordError: {
	        'zh-CN': '密码错误',
	        'zh-TW': '密碼錯誤',
	        'en-US': 'Password error',
	        'th-TH': 'Password error',
	        'vi-VN': 'Password error'
	    },
	    userNotExits: {
	        'zh-CN': '用户名不存在',
	        'zh-TW': '用戶名不存在',
	        'en-US': 'User not exists',
	        'th-TH': 'User not exists',
	        'vi-VN': 'User not exists'
	    },
	    loginFail: {
	        'zh-CN': '登录失败',
	        'zh-TW': '登錄失敗',
	        'en-US': 'Login Failed',
	        'th-TH': 'Login Failed',
	        'vi-VN': 'Login Failed'
	    },
	    loginFailErrorCode: {
	        'zh-CN': '登录失败，错误码为：',
	        'zh-TW': '登錄失敗，錯誤碼為：',
	        'en-US': 'Login failed, error code: ',
	        'th-TH': 'Login failed, error code: ',
	        'vi-VN': 'Login failed, error code: '
	    },
	    registerFail: {
	        'zh-CN': '注册失败',
	        'zh-TW': '註冊失敗',
	        'en-US': 'Registration Failed',
	        'th-TH': 'Registration Failed',
	        'vi-VN': 'Registration Failed'
	    },
	    registerFailErrorCode: {
	        'zh-CN': '注册失败，错误码为：',
	        'zh-TW': '註冊失敗，錯誤碼為：',
	        'en-US': 'Registration failed，error code:',
	        'th-TH': 'Registration failed，error code:',
	        'vi-VN': 'Registration failed，error code:'
	    }
	};

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    close: {
	        'zh-CN': '关闭',
	        'zh-TW': '關閉',
	        'en-US': 'close',
	        'th-TH': 'close'
	    },
	    prevPage: {
	        'zh-CN': '上一页',
	        'zh-TW': '上一頁',
	        'en-US': 'Preview',
	        'th-TH': 'Preview'
	    },
	    nextPage: {
	        'zh-CN': '下一页',
	        'zh-TW': '下一頁',
	        'en-US': 'Next',
	        'th-TH': 'Next'
	    }
	};

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    pleaseLogin: {
	        'zh-CN': '您好，请登录',
	        'zh-TW': '您好，請登錄',
	        'en-US': 'Login',
	        'th-TH': 'ล็อกอิน',
	        'vi-VN': 'Hãy đăng nhập'
	    },
	    register: {
	        'zh-CN': '注册账号',
	        'zh-TW': '註冊帳號',
	        'en-US': 'Register',
	        'th-TH': 'การลงทะเบียน',
	        'vi-VN': 'Đăng ký'
	    },
	    userRegister: {
	        'zh-CN': '注册',
	        'zh-TW': '註冊',
	        'en-US': 'Register',
	        'th-TH': 'ลงทะเบียนทันที',
	        'vi-VN': 'Đăng ký'
	    },
	    login: {
	        'zh-CN': '登录',
	        'zh-TW': '登錄',
	        'en-US': 'Sign in',
	        'th-TH': 'ล็อกอินบัญชี',
	        'vi-VN': 'Đăng nhập'
	    },
	    loginEgAccount: {
	        'zh-CN': '登录账号',
	        'zh-TW': '登錄賬號',
	        'en-US': 'Sign in',
	        'th-TH': 'ล็อกอินบัญชี',
	        'vi-VN': 'Đăng nhập'
	    },
	    rememberAccount: {
	        'zh-CN': '记住账号',
	        'zh-TW': '記住賬號',
	        'en-US': 'Remember me',
	        'th-TH': 'จำบัญชี',
	        'vi-VN': 'Ghi nhớ tài khoản'
	    },
	    captchaCodeError: {
	        'zh-CN': '验证码错误',
	        'zh-TW': '驗證碼錯誤',
	        'en-US': 'Captcha error',
	        'th-TH': 'รหัสยืนยันผิด',
	        'vi-VN': 'Lỗi mã xác nhận'
	    },
	    inputAccount: {
	        'zh-CN': '请输入账号',
	        'zh-TW': '請輸入賬號',
	        'en-US': 'Please enter account',
	        'th-TH': 'โปรดกรอกบัญชี',
	        'vi-VN': 'Nhập Tài Khoản'
	    },
	    inputPassword: {
	        'zh-CN': '请输入密码',
	        'zh-TW': '請輸入密碼',
	        'en-US': 'Please enter password',
	        'th-TH': 'โปรดกรอกรหัส',
	        'vi-VN': 'Nhập mật khẩu'
	    },
	    inputCaptcha: {
	        'zh-CN': '请输入验证码',
	        'zh-TW': '請輸入驗證碼',
	        'en-US': 'Please enter captcha',
	        'th-TH': 'โปรดกรอกรหัสยืนยัน',
	        'vi-VN': 'Nhận mã xác nhận'
	    },
	    logout: {
	        'zh-CN': '退出',
	        'zh-TW': '退出',
	        'en-US': 'Logout',
	        'th-TH': 'ออก',
	        'vi-VN': 'Đăng xuất'
	    },
	    egPoint: {
	        'zh-CN': 'EG点',
	        'zh-TW': 'EG點',
	        'en-US': 'EG Points',
	        'th-TH': 'แต้มEG',
	        'vi-VN': 'Điểm EG'
	    },
	    buyGoods: {
	        'zh-CN': '购买商品',
	        'zh-TW': '購買商品',
	        'en-US': 'Purchase',
	        'th-TH': 'ซื้อสินค้า',
	        'vi-VN': 'Mua hàng'
	    },
	    egRecharge: {
	        'zh-CN': 'EG点充值',
	        'zh-TW': 'EG點充值',
	        'en-US': 'EG Recharge',
	        'th-TH': 'แต้มEGเติมเงิน',
	        'vi-VN': 'Nạp điểm EG'
	    },
	    consumeRecords: {
	        'zh-CN': '商品交易记录',
	        'zh-TW': '商品交易記錄',
	        'en-US': 'Transaction Records',
	        'th-TH': 'บันทึกการซื้อของ',
	        'vi-VN': 'Lịch sử mua hàng'
	    },
	    rechargeRecords: {
	        'zh-CN': 'EG点充值记录',
	        'zh-TW': 'EG點充值記錄',
	        'en-US': 'Recharge Records',
	        'th-TH': 'บันทึกเติมแต้มEG',
	        'vi-VN': 'Kỷ lục Recharge điểm EG'
	    },
	    noGames: {
	        'zh-CN': '暂无可用的游戏',
	        'zh-TW': '暫無可用的遊戲',
	        'en-US': 'No games available',
	        'th-TH': 'ยังไม่มีเกมเล่นได้',
	        'vi-VN': 'không có trò chơi'
	    },
	    noGoods: {
	        'zh-CN': '该游戏暂无商品',
	        'zh-TW': '該遊戲暫無商品',
	        'en-US': 'No goods available',
	        'th-TH': 'เกมนี้ยังไม่มีสินค้า',
	        'vi-VN': 'Không có hàng'
	    },
	    statusAll: {
	        'zh-CN': '所有订单',
	        'zh-TW': '所有訂單',
	        'en-US': 'All',
	        'th-TH': 'ใบสั่งทั้งหมด',
	        'vi-VN': 'Tất cả đơn hàng'
	    },
	    statusPending: {
	        'zh-CN': '支付中',
	        'zh-TW': '支付中',
	        'en-US': 'Pending',
	        'th-TH': 'ชำระอยู่',
	        'vi-VN': 'Đang thanh toán'
	    },
	    statusSuccess: {
	        'zh-CN': '已完成',
	        'zh-TW': '已完成',
	        'en-US': 'Success',
	        'th-TH': 'สำเร็จแล้ว',
	        'vi-VN': 'Đã hoàn thành'
	    },
	    statusFail: {
	        'zh-CN': '已失败',
	        'zh-TW': '已失敗',
	        'en-US': 'Failed',
	        'th-TH': 'ล้มเหลว',
	        'vi-VN': 'Thất bại'
	    },
	    orderDate: {
	        'zh-CN': '订单时间',
	        'zh-TW': '訂單時間',
	        'en-US': 'Order Date',
	        'th-TH': 'เวลาใบสั่ง',
	        'vi-VN': 'Ngày đặt hàng'
	    },
	    search: {
	        'zh-CN': '查询',
	        'zh-TW': '查詢',
	        'en-US': 'Search',
	        'th-TH': 'ตรวจ',
	        'vi-VN': 'Kiểm tra'
	    },
	    selectDateRange: {
	        'zh-CN': '选择日期范围',
	        'zh-TW': '選擇日期範圍',
	        'en-US': 'Select Date Range',
	        'th-TH': 'เลือกขอบเขตเวลา',
	        'vi-VN': 'Chọn phạm vi ngày'
	    },
	    selectChannel: {
	        'zh-CN': '请选择支付方式',
	        'zh-TW': '請選擇支付方式',
	        'en-US': 'Select payment method',
	        'th-TH': 'เลือกวิธีชำระ',
	        'vi-VN': 'Hãy chọn phương thức thanh toán'
	    },
	    selectChannelNew: {
	        'zh-CN': 'LunaM預註冊點卡兌換',
	        'zh-TW': 'LunaM預註冊點卡兌換',
	        'en-US': 'LunaM pre-registration point card exchange',
	        'th-TH': 'LunaM pre-registration point card exchange',
	        'vi-VN': 'Trao đổi thẻ đăng ký trước LunaM'
	    },
	    purchase: {
	        'zh-CN': '购买',
	        'zh-TW': '購買',
	        'en-US': 'Purchase',
	        'th-TH': 'ซื้อ',
	        'vi-VN': 'Mua'
	    },
	    changeCaptcha: {
	        'zh-CN': '看不清，换一张',
	        'zh-TW': '看不清，換一張',
	        'en-US': 'Unclear? Another one',
	        'th-TH': 'เห็นไม่ชัด เปลี่ยนอื่น',
	        'vi-VN': 'Nhìn không rõ, thay đổi một'
	    },
	    recordDate: {
	        'zh-CN': '交易时间',
	        'zh-TW': '交易時間',
	        'en-US': 'Exchange Date',
	        'th-TH': 'เวลาซื้อขาย',
	        'vi-VN': 'Thời gian đặt hàng'
	    },
	    appName: {
	        'zh-CN': '应用名称',
	        'zh-TW': '應用名稱',
	        'en-US': 'App Name',
	        'th-TH': 'ชื่อApp',
	        'vi-VN': 'Tên ứng dùng'
	    },
	    goodsName: {
	        'zh-CN': '商品名称',
	        'zh-TW': '商品名稱',
	        'en-US': 'Goods Name',
	        'th-TH': 'ชื่อสินค้า',
	        'vi-VN': 'Tên hàng'
	    },
	    goodsPrice: {
	        'zh-CN': '商品价格',
	        'zh-TW': '商品價格',
	        'en-US': 'Goods Price',
	        'th-TH': 'ราคาสินค้า',
	        'vi-VN': 'Giá hàng'
	    },
	    orderId: {
	        'zh-CN': '订单号',
	        'zh-TW': '訂單號',
	        'en-US': 'Order ID',
	        'th-TH': 'IDใบสั่ง',
	        'vi-VN': 'Số đơn hàng'
	    },
	    orderStatus: {
	        'zh-CN': '订单状态',
	        'zh-TW': '訂單狀態',
	        'en-US': 'Order Status',
	        'th-TH': 'สภาพใบสั่ง',
	        'vi-VN': ' Trạng thái đơn hàng'
	    },
	    rechargeChannel: {
	        'zh-CN': '充值渠道',
	        'zh-TW': '儲值渠道',
	        'en-US': 'Pay Channel',
	        'th-TH': 'ช่องทางเติมเงิน',
	        'vi-VN': 'Kênh nạp thẻ'
	    },
	    rechargeAmount: {
	        'zh-CN': '充值金额',
	        'zh-TW': '儲值金額',
	        'en-US': 'Amount',
	        'th-TH': 'จำนวนเติมเงิน',
	        'vi-VN': 'Mệnh giá nạp'
	    },
	    confirmOrder: {
	        'zh-CN': '订单确认',
	        'zh-TW': '訂單確認',
	        'en-US': 'Confirm Order',
	        'th-TH': 'ยืนยันใบสั่ง',
	        'vi-VN': 'Xác nhận'
	    },
	    gameArea: {
	        'zh-CN': '游戏大区',
	        'zh-TW': '遊戲大廳',
	        'en-US': 'Game Area',
	        'th-TH': 'เขต',
	        'vi-VN': 'Khu vực game'
	    },
	    gameServer: {
	        'zh-CN': '游戏区服',
	        'zh-TW': '遊戲區服',
	        'en-US': 'Game Server',
	        'th-TH': 'โซน',
	        'vi-VN': 'Máy chủ'
	    },
	    roleName: {
	        'zh-CN': '角色名称',
	        'zh-TW': '角色名稱',
	        'en-US': 'Character Name',
	        'th-TH': 'ชื่อตัวละคร',
	        'vi-VN': 'Tên nhân vật'
	    },
	    loginPassword: {
	        'zh-CN': '登录密码',
	        'zh-TW': '登錄密碼',
	        'en-US': 'Login Password',
	        'th-TH': 'รหัสล็อกอิน',
	        'vi-VN': 'Mật khẩu'
	    },
	    confirmBuy: {
	        'zh-CN': '确定购买',
	        'zh-TW': '確定購買',
	        'en-US': 'Confirm',
	        'th-TH': 'ยืนยันซื้อ',
	        'vi-VN': 'xác nhận'
	    },
	    cancelBuy: {
	        'zh-CN': '取消购买',
	        'zh-TW': '取消購買',
	        'en-US': 'Cancel',
	        'th-TH': 'ยกเลิก',
	        'vi-VN': 'Hủy'
	    },
	    areaAsia: {
	        'zh-CN': '亚太',
	        'zh-TW': '亞太',
	        'en-US': 'Asia Oceania',
	        'th-TH': 'เอเชียแปซิฟิก',
	        'vi-VN': 'Đông Nam Á'
	    },
	    areaAmerica: {
	        'zh-CN': '北美/南美',
	        'zh-TW': '北美/南美',
	        'en-US': 'North America/South America',
	        'th-TH': 'อเมริกาเหนือ/อเมริกาใต้',
	        'vi-VN': 'Bắc/Nam Mỹ'
	    },
	    areaEurope: {
	        'zh-CN': '欧洲/非洲',
	        'zh-TW': '歐洲/非洲',
	        'en-US': 'Europe/Africa',
	        'th-TH': 'ยุโรป/แอฟริกา',
	        'vi-VN': 'Châu Âu/ Châu Phi'
	    },
	    selectGameServer: {
	        'zh-CN': '请选择游戏区服',
	        'zh-TW': '請選擇遊戲區服',
	        'en-US': 'Select game server',
	        'th-TH': 'กรุณาเลือกโซน',
	        'vi-VN': 'Chọn Khu vực'
	    },
	    use: {
	        'zh-CN': '用',
	        'zh-TW': '用',
	        'en-US': 'Use ',
	        'th-TH': 'ใช้',
	        'vi-VN': 'Sử dùng'
	    },
	    buyEgPoint: {
	        'zh-CN': '购买EG点',
	        'zh-TW': '購買EG點',
	        'en-US': ' Buy EG Points',
	        'th-TH': 'ซื้อแต้มEG',
	        'vi-VN': 'Mua điểm EG'
	    },
	    cardNo: {
	        'zh-CN': '卡号',
	        'zh-TW': '卡號',
	        'en-US': 'Card',
	        'th-TH': 'การ์ด',
	        'vi-VN': 'Số thẻ'
	    },
	    serialNo: {
	        'zh-CN': '序列号',
	        'zh-TW': '序列號',
	        'en-US': 'Serial',
	        'th-TH': 'ซีเรียล',
	        'vi-VN': 'Số xê ri'
	    },
	    cardNotEmpty: {
	        'zh-CN': '卡号不能为空',
	        'zh-TW': '卡號不能為空',
	        'en-US': 'Card is needed',
	        'th-TH': 'การ์ดเป็นช่องว่างไม่ได้',
	        'vi-VN': 'Số thể không được để trống'
	    },
	    serialNotEmpty: {
	        'zh-CN': '序列号不能为空',
	        'zh-TW': '序列號不能為空',
	        'en-US': 'Serial is needed',
	        'th-TH': 'ซีเรียลเป็นช่องว่างไม่ได้',
	        'vi-VN': 'Số xê ri không được để trống'
	    },
	    selectCurrency: {
	        'zh-CN': '请选择币种',
	        'zh-TW': '請選擇幣種',
	        'en-US': 'Select currency',
	        'th-TH': 'โปรดเลือกสกุลเงิน',
	        'vi-VN': 'Chọn loại tiền tệ'
	    },
	    rechargeSuccess: {
	        'zh-CN': '充值成功',
	        'zh-TW': '儲值成功',
	        'en-US': 'Recharge Success',
	        'th-TH': 'เติมเงินสำเร็จ',
	        'vi-VN': 'Thanh toán thành công'
	    },
	    rechargeSuccessAmount: {
	        'zh-CN': '成功充值',
	        'zh-TW': '成功儲值',
	        'en-US': 'Recharge Success：',
	        'th-TH': 'สำเร็จเติมเงิน',
	        'vi-VN': 'Thanh toán thành công'
	    },
	    rechargeFinish: {
	        'zh-CN': '充值完成',
	        'zh-TW': '儲值完成',
	        'en-US': 'Recharge Finish',
	        'th-TH': 'เติมเงินเสร็จแล้ว',
	        'vi-VN': 'Hoàn thành'
	    },
	    rechargeFinishCheckLater: {
	        'zh-CN': '充值完成，请稍后查询充值结果',
	        'zh-TW': '儲值完成，請稍後查詢儲值結果',
	        'en-US': 'Recharge finish, check recharge result later',
	        'th-TH': 'เติมเงินเสร็จแล้ว โปรดตรวจผลทีหลัง',
	        'vi-VN': 'Bạn đã thanh toán thành công,vui lòng một lát nữa kiểm tra kết quả nạp tiền.'
	    },
	    rechargeCancel: {
	        'zh-CN': '充值取消',
	        'zh-TW': '儲值取消',
	        'en-US': 'Recharge Cancel',
	        'th-TH': 'ยกเลิกเติมเงิน',
	        'vi-VN': 'Hủy thanh toán '
	    },
	    rechargeCancelQuestAgain: {
	        'zh-CN': '充值取消，如需充值请再次发起请求',
	        'zh-TW': '儲值取消，如需儲值請再次發起請求',
	        'en-US': 'Recharge canceled, try again',
	        'th-TH': 'ยกเลิกเติมเงิน ถ้าอยากเติมเงินกรุณาลองใหม่',
	        'vi-VN': 'thanh toán bị hủy. Nếu bạn cần nạp vui lòng thử lại.'
	    },
	    rechargeFail: {
	        'zh-CN': '充值失败',
	        'zh-TW': '儲值失敗',
	        'en-US': 'Recharge Fail',
	        'th-TH': 'เติมเงินล้มเหลว',
	        'vi-VN': 'thanh toán thất bại'
	    },
	    rechargeFailErrCode: {
	        'zh-CN': '充值失败，错误码为：',
	        'zh-TW': '儲值失敗，錯誤碼為：',
	        'en-US': 'Recharge fail, error code: ',
	        'th-TH': 'เติมเงินล้มเหลว codeคือ:',
	        'vi-VN': 'thanh toán thất bại,Mã lỗi là:'
	    },
	    createOrderFail: {
	        'zh-CN': '创建订单失败',
	        'zh-TW': '創建訂單失敗',
	        'en-US': 'Create Order Fail',
	        'th-TH': 'สร้างใบสั่งล้มเหลว',
	        'vi-VN': 'Tạo đơn hàng thất bại'
	    },
	    createOrderFailTryAgain: {
	        'zh-CN': '订单创建失败，请稍后再试',
	        'zh-TW': '創建訂單失敗，請稍後再試',
	        'en-US': 'Create order fail, try again later',
	        'th-TH': 'สร้างใบสั่งล้มเหลว กรุณาลองใหม่ทีหลัง',
	        'vi-VN': 'Tạo đơn hàng thất bại, hãy thử lại'
	    },
	    systemError: {
	        'zh-CN': '系统错误',
	        'zh-TW': '系統錯誤',
	        'en-US': 'System Error',
	        'th-TH': 'ระบบผิดพลาด',
	        'vi-VN': 'Lỗi hệ thống'
	    },
	    systemErrorTryLater: {
	        'zh-CN': '系统错误，请稍后再试',
	        'zh-TW': '系統錯誤，請稍後再試',
	        'en-US': 'System error, try again later',
	        'th-TH': 'ระบบผิดพลาด กรุณาลองใหม่ทีหลัง',
	        'vi-VN': 'Lỗi hệ thống, hãy thử lại'
	    },
	    confirm: {
	        'zh-CN': '确定',
	        'zh-TW': '確定',
	        'en-US': 'Confirm',
	        'th-TH': 'ยืนยัน',
	        'vi-VN': 'Xác nhận'
	    },
	    noRoleInServer: {
	        'zh-CN': '您在该服务器上无角色',
	        'zh-TW': '您在該服務器上無角色',
	        'en-US': 'No character in the server',
	        'th-TH': 'โซนนี้ไม่มีตัวละคร',
	        'vi-VN': 'Không có vai trò'
	    },
	    getRoleFail: {
	        'zh-CN': '获取角色信息失败',
	        'zh-TW': '獲取角色信息失敗',
	        'en-US': 'Get character fail',
	        'th-TH': 'ได้ข้อมูลตัวละครล้มเหลว',
	        'vi-VN': 'Không thể lấy thông tin vai trò'
	    },
	    noRoleMsg: {
	        'zh-CN': '无角色',
	        'zh-TW': '无角色',
	        'en-US': 'no role',
	        'th-TH': 'ไม่มีบทบาท',
	        'vi-VN': 'Không có vai trò'
	    },
	    getServerFail: {
	        'zh-CN': '获取服务器列表失败',
	        'zh-TW': '獲取服務器列表失敗',
	        'en-US': 'Get server list fail',
	        'th-TH': 'ได้รายการโซนล้มเหลว',
	        'vi-VN': 'Không thể lấy danh sách máy chủ'
	    },
	    pleaseInputPassword: {
	        'zh-CN': '请填写密码',
	        'zh-TW': '請填寫密碼',
	        'en-US': 'Please enter password',
	        'th-TH': 'โปรดกรอกรหัส',
	        'vi-VN': 'Nhập mật khẩu'
	    },
	    createGoodsOrderFail: {
	        'zh-CN': '创建订单失败！',
	        'zh-TW': '創建訂單失敗！',
	        'en-US': 'Create order fail',
	        'th-TH': 'สร้างใบสั่งล้มเหลว',
	        'vi-VN': 'Tạo đơn hàng thất bại'
	    },
	    buyGoodsSuccess: {
	        'zh-CN': '购买成功！',
	        'zh-TW': '購買成功！',
	        'en-US': 'Buy goods success',
	        'th-TH': 'ซื้อสำเร็จ',
	        'vi-VN': 'Thanh toán thành công'
	    },
	    buyGoodsFail: {
	        'zh-CN': '购买失败',
	        'zh-TW': '購買失敗',
	        'en-US': 'Buy goods fail',
	        'th-TH': 'ซื้อล้มเหลว',
	        'vi-VN': 'Thanh toán thất bại'
	    },
	    buyGoodsFailErrorCode: {
	        'zh-CN': '购买失败，错误码为：',
	        'zh-TW': '購買失敗，錯誤碼為：',
	        'en-US': 'Buy goods fail, error code: ',
	        'th-TH': 'ซื้อล้มเหลว codeคือ:',
	        'vi-VN': 'thanh toán thất bại,Mã lỗi là:'
	    },
	    networkError: {
	        'zh-CN': '网络错误，请稍后再试',
	        'zh-TW': '網絡錯誤，請稍後再試',
	        'en-US': 'Network error, try again later',
	        'th-TH': 'เคลือข่ายล้มเหลว กรุณาลองใหม่ทีหลัง',
	        'vi-VN': 'Bạn bị mất kết nối, hãy thử lại'
	    },
	    nextPage: {
	        'zh-CN': '下一页',
	        'zh-TW': '下一頁',
	        'en-US': 'Next',
	        'th-TH': 'หน้าถัดไป',
	        'vi-VN': 'Tiếp theo'
	    },
	    previewPage: {
	        'zh-CN': '上一页',
	        'zh-TW': '上一頁',
	        'en-US': 'Preview',
	        'th-TH': 'หน้าก่อนหน้า',
	        'vi-VN': 'Trang trước'
	    },
	    lastWeek: {
	        'zh-CN': '最近一周',
	        'zh-TW': '最近一周',
	        'en-US': 'Last week',
	        'th-TH': 'สัปดาห์ที่แล้ว',
	        'vi-VN': 'Tuần trước'
	    },
	    lastMonth: {
	        'zh-CN': '最近一个月',
	        'zh-TW': '最近一個月',
	        'en-US': 'Last month',
	        'th-TH': 'เดือนที่แล้ว',
	        'vi-VN': 'Tháng trước'
	    },
	    lastThreeMonth: {
	        'zh-CN': '最近三个月',
	        'zh-TW': '最近三個月',
	        'en-US': 'Last 3 months',
	        'th-TH': '3เดือนที่แล้ว',
	        'vi-VN': '3 tháng qua'
	    },
	    noRecords: {
	        'zh-CN': '无记录',
	        'zh-TW': '無記錄',
	        'en-US': 'No Records',
	        'th-TH': 'ไม่มีบันทึก',
	        'vi-VN': 'Không có hồ sơ'
	    },
	    downloadGame: {
	        'zh-CN': '下载游戏',
	        'zh-TW': '下載遊戲',
	        'en-US': 'Download Game',
	        'th-TH': 'ดาวโหลดเกม',
	        'vi-VN': 'Cài đặt'
	    },
	    passwordError: {
	        'zh-CN': '密码错误',
	        'zh-TW': '密碼錯誤',
	        'en-US': 'Password error',
	        'th-TH': 'Password error',
	        'vi-VN': 'Sai mật khẩu'
	    },
	    userNotExits: {
	        'zh-CN': '用户名不存在',
	        'zh-TW': '用戶名不存在',
	        'en-US': 'User not exists',
	        'th-TH': 'User not exists',
	        'vi-VN': 'Tên đăng nhập không tồn tại'
	    },
	    egPointNotEnough: {
	        'zh-CN': 'EG点数不足',
	        'zh-TW': 'EG點數不足',
	        'en-US': 'EG point not enough',
	        'th-TH': 'EG point not enough',
	        'vi-VN': 'Điểm EG không đủ'
	    },
	    isBlocked: {
	        'zh-CN': '此账号已被封禁，如需解禁请联系客服',
	        'zh-TW': '此賬號已被封禁，如需解禁請聯繫客服',
	        'en-US': 'This account is blocked, please contact CS',
	        'th-TH': 'บัญชีของคุณห้ามใช้แล้ว กรุณาติดต่อฝ่ายบริการลูกค้า',
	        'vi-VN': 'Tài khoản của bạn đã bị cấm. Nếu bạn cần gỡ bỏ lệnh cấm, vui lòng liên hệ với CSKH.'
	    },
	    payNow: {
	        'zh-CN': '前往支付渠道',
	        'zh-TW': '前往支付渠道',
	        'en-US': 'Pay now',
	        'th-TH': 'ไปสู่ช่องทางชำระ',
	        'vi-VN': 'Chuyển đến kênh thanh toán '
	    },
	    userIsExist: {
	        'zh-CN': '该用户名已存在',
	        'zh-TW': '該用戶名已存在',
	        'en-US': 'User name is already exist',
	        'th-TH': 'ชื่อผู้ใช้นี้มีอยู่แล้ว',
	        'vi-VN': 'Tên đăng nhập đã tồn tại'
	    },
	    service: {
	        'zh-CN': '服务条款',
	        'zh-TW': '服務條款',
	        'en-US': 'Service Policy',
	        'th-TH': 'รายาการบริการ',
	        'vi-VN': 'Điều khoản phục vụ'
	    },
	    notValid: {
	        'zh-CN': '请输入有效的账号和密码',
	        'zh-TW': '請輸入有效的賬號和密碼',
	        'en-US': 'Please enter valid account and password',
	        'th-TH': 'กรุณากรอกบัญชีและรหัสถูกต้อง',
	        'vi-VN': 'Hãy nhập tài khoản và mật khẩu chính xác'
	    },
	    selectService: {
	        'zh-CN': '请阅读并同意服务条款',
	        'zh-TW': '請閱讀並同意服務條款',
	        'en-US': 'Read and accept service policy',
	        'th-TH': 'กรุณาอ่านและยืนยันรายาการบริการ',
	        'vi-VN': ' Hãy đọc và đồng ý với điều khoản'
	    },
	    codeError: {
	        'zh-CN': '验证码超时',
	        'zh-TW': '驗證碼超時',
	        'en-US': 'Verification Code Timeout',
	        'th-TH': 'รหัสยืนยันหมดอายุ',
	        'vi-VN': 'Quá thời gian nhận mã xác nhận'
	    }
	};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Home = function Home(resolve) {
	    return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(344)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var About = function About(resolve) {
	    return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(341)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Game = function Game(resolve) {
	    return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(343)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Business = function Business(resolve) {
	    return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(342)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var News = function News(resolve) {
	    return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(345)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Store = function Store(resolve) {
	    return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(348)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Consume = function Consume(resolve) {
	    return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(360)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Recharge = function Recharge(resolve) {
	    return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(362)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Records = function Records(resolve) {
	    return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(363)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var NewsDetail = function NewsDetail(resolve) {
	    return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(346)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Result = function Result(resolve) {
	    return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(347)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	exports.default = [{
	    path: '/',
	    redirect: '/home'
	}, {
	    path: '/result',
	    meta: { auth: false },
	    component: Result
	}, {
	    path: '/home',
	    meta: { auth: false },
	    component: Home
	}, {
	    path: '/about',
	    meta: { auth: false },
	    component: About
	}, {
	    path: '/game',
	    meta: { auth: false },
	    component: Game
	}, {
	    path: '/business',
	    meta: { auth: false },
	    component: Business
	}, {
	    path: '/news',
	    meta: { auth: false },
	    component: News
	}, {
	    path: '/news/:id',
	    meta: { auth: false },
	    component: NewsDetail
	}, {
	    path: '*',
	    redirect: 'home'
	}];

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(116);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutations = __webpack_require__(192);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _user = __webpack_require__(191);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _records = __webpack_require__(190);
	
	var _records2 = _interopRequireDefault(_records);
	
	var _consume = __webpack_require__(189);
	
	var _consume2 = _interopRequireDefault(_consume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	    state: {
	        rechargeChannels: [],
	        showLoginPopup: false,
	        showRegisterPopup: false,
	        loginPath: '',
	        totalEg: '...'
	    },
	    mutations: _mutations2.default,
	    modules: {
	        user: _user2.default,
	        records: _records2.default,
	        consume: _consume2.default
	    }
	});

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations, _actions;
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(16);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _consume = __webpack_require__(167);
	
	var _consume2 = _interopRequireDefault(_consume);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        appList: [],
	        goodsList: {},
	        playedGames: [],
	        serverList: {}
	    },
	    getters: {
	        areaList: function areaList() {
	            return {
	                1: _vue2.default.t('areaAsia'),
	                2: _vue2.default.t('areaAmerica'),
	                3: _vue2.default.t('areaEurope')
	            };
	        },
	        playedGamesList: function playedGamesList(state) {
	            var games = [];
	            state.playedGames.forEach(function (game) {
	                games.push(parseInt(game.id));
	            });
	            return games;
	        }
	    },
	    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_APP_LIST, function (state, appList) {
	        state.appList = appList;
	    }), (0, _defineProperty3.default)(_mutations, types.SET_GOODS_LIST, function (state, goods) {
	        if (goods.appId !== 0) {
	            state.goodsList[goods.appId] = goods.goodsList;
	        }
	    }), (0, _defineProperty3.default)(_mutations, types.SET_USER_PLAYED_GAME, function (state, playedGames) {
	        state.playedGames = playedGames;
	    }), (0, _defineProperty3.default)(_mutations, types.SET_SERVER_LIST, function (state, server) {
	        if (!state.serverList[server.appId]) {
	            state.serverList[server.appId] = {};
	        }
	        state.serverList[server.appId][server.areaId] = server.serverList;
	    }), _mutations),
	    actions: (_actions = {}, (0, _defineProperty3.default)(_actions, types.GET_APP_LIST, function (_ref) {
	        var commit = _ref.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getAppList(function (appList) {
	                commit(types.SET_APP_LIST, appList);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.GET_GOODS_LIST, function (_ref2, appId) {
	        var commit = _ref2.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getGoodsList(appId, function (goods) {
	                commit(types.SET_GOODS_LIST, goods);
	                resolve(goods.goodsList);
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.GET_USER_PLAYED_GAME, function (_ref3, params) {
	        var commit = _ref3.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getPlayedGames(params, function (playedGames) {
	                commit(types.SET_USER_PLAYED_GAME, playedGames);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.GET_SERVER_LIST, function (_ref4, params) {
	        var commit = _ref4.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getServerList(params, function (serverList) {
	                var server = {
	                    appId: params.appId,
	                    areaId: params.areaId,
	                    serverList: serverList
	                };
	                commit(types.SET_SERVER_LIST, server);
	                resolve(serverList);
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.GET_ROLE_INFO, function (_ref5, params) {
	        var commit = _ref5.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getRoleInfo(params, function (roleInfo) {
	                resolve(roleInfo);
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.EG_BUY_GOODS, function (_ref6, params) {
	        var commit = _ref6.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.egBuyGoods(params, function (apiResult) {
	                resolve(apiResult);
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), _actions)
	};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(16);
	
	var _records = __webpack_require__(168);
	
	var _records2 = _interopRequireDefault(_records);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDate(timestamp) {
	    if (!timestamp) return "";
	    timestamp = parseInt(timestamp);
	    var date = new Date(timestamp);
	    var year = date.getFullYear();
	    var month = date.getMonth() + 1;
	    var day = date.getDate();
	    var hour = date.getHours();
	    var minutes = date.getMinutes();
	    var seconds = date.getSeconds();
	    return year + '/' + formatNum(month) + '/' + formatNum(day) + ' ' + formatNum(hour) + ':' + formatNum(minutes) + ':' + formatNum(seconds);
	}
	
	function formatNum(num) {
	    var newNum = num + "";
	    if (newNum.length == 1) {
	        return "0" + newNum;
	    }
	    return newNum;
	}
	
	function getChannelName(channelId) {
	    var name = {
	        10001: 'Fortumo',
	        10002: 'Fortumo',
	        10003: 'Mol',
	        10004: 'Mol',
	        10005: 'BluePay',
	        10006: 'BluePay',
	        10007: 'Gash',
	        10008: '1Pay',
	        10009: 'VNPT',
	        10010: 'Mimopay',
	        10011: 'Mimopay',
	        10012: 'Codapay',
	        10013: 'Upay',
	        10014: 'MyCard',
	        10015: 'MyCard',
	        10016: 'PayPal',
	        10017: 'UniPin',
	        10018: 'UniPin',
	        10019: 'Paymentwall',
	        10020: '支付宝',
	        10022: '天天賺'
	    };
	    return name[parseInt(channelId)];
	}
	
	function getStatusName(statusCode) {
	    var status = statusCode + '';
	    var statusName = {
	        '0': _vue2.default.t('statusPending'),
	        '50': _vue2.default.t('statusPending'),
	        '100': _vue2.default.t('statusSuccess'),
	        '-50': _vue2.default.t('statusFail')
	    };
	    return statusName[status];
	}
	
	function formatRecords(recordsType, recordsData) {
	    if (recordsData.length == 0) {
	        return [];
	    }
	    var result = [];
	    for (var i = 0; i < recordsData.length; i++) {
	        var record = recordsData[i];
	        var newRecord = {};
	        newRecord.orderDate = formatDate(record.createDate);
	        if (recordsType == 'consume') {
	            newRecord.appName = record.appName;
	            newRecord.goodsName = record.goodsName;
	            newRecord.goodsPrice = record.currency + ' ' + record.totalMoney;
	        } else {
	            newRecord.channelName = getChannelName(record.payPlatformId);
	            newRecord.rechargeAmount = record.currency + ' ' + record.totalMoney;
	            newRecord.egPoint = record.egPoint;
	        }
	        newRecord.orderId = record.id;
	        newRecord.orderStatus = getStatusName(record.status);
	        result[i] = newRecord;
	    }
	    return result;
	}
	
	exports.default = {
	    state: {
	        consumeRecords: [],
	        rechargeRecords: []
	    },
	    getters: {
	        consumeRecordsList: function consumeRecordsList(state) {
	            var list = state.consumeRecords;
	            if (list.length === 0) {
	                return [];
	            }
	            return formatRecords('consume', list);
	        },
	        rechargeRecordsList: function rechargeRecordsList(state) {
	            var list = state.rechargeRecords;
	            if (list.length === 0) {
	                return [];
	            }
	            return formatRecords('recharge', list);
	        }
	    },
	    mutations: (0, _defineProperty3.default)({}, _mutationTypes.SET_RECORDS, function (state, records) {
	        if (records.recordsType === 'consume') {
	            state.consumeRecords = records.data;
	        } else {
	            state.rechargeRecords = records.data;
	        }
	    }),
	    actions: (0, _defineProperty3.default)({}, _mutationTypes.GET_RECORDS, function (_ref, params) {
	        var commit = _ref.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _records2.default.getRecords(params, function (records) {
	                commit(_mutationTypes.SET_RECORDS, records);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    })
	};

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(30);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(84);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mutations, _actions;
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(16);
	
	var _user = __webpack_require__(82);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: JSON.parse(sessionStorage.getItem('user')) || {},
	    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_LOGIN, function (state, user) {
	        sessionStorage.setItem('user', (0, _stringify2.default)(user));
	        (0, _assign2.default)(state, user);
	    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_LOGOUT, function (state) {
	        sessionStorage.removeItem('user');
	        (0, _keys2.default)(state).forEach(function (k) {
	            return _vue2.default.delete(state, k);
	        });
	    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_REGISTER, function (state, user) {
	        sessionStorage.setItem('user', (0, _stringify2.default)(user));
	        (0, _assign2.default)(state, user);
	    }), _mutations),
	    actions: (_actions = {}, (0, _defineProperty3.default)(_actions, _mutationTypes.USER_LOGIN, function (_ref, user) {
	        var commit = _ref.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _user2.default.login(user, function (userInfo) {
	                commit(_mutationTypes.USER_LOGIN, userInfo);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, _mutationTypes.USER_REGISTER, function (_ref2, user) {
	        var commit = _ref2.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _user2.default.register(user, function (userInfo) {
	                commit(_mutationTypes.USER_REGISTER, userInfo);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, _mutationTypes.USER_LOGOUT, function (_ref3) {
	        var commit = _ref3.commit;
	
	        commit(_mutationTypes.USER_LOGOUT);
	    }), _actions)
	};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(82);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    storeRechargeChannels: function storeRechargeChannels(state, channels) {
	        state.rechargeChannels = channels;
	    },
	    controlLoginPopup: function controlLoginPopup(state, status) {
	        state.showLoginPopup = status;
	    },
	    controlRegisterPopup: function controlRegisterPopup(state, status) {
	        state.showRegisterPopup = status;
	    },
	    setLoginPath: function setLoginPath(state, path) {
	        state.loginPath = path;
	    },
	    getTotalEg: function getTotalEg(state) {
	        var uid = state.user.uid;
	        _user2.default.getEg(uid, function (eg) {
	            state.totalEg = eg;
	        });
	    }
	};

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/jubao.4e38242.png";

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/mengguo_logo.ba3deeb.png";

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(300)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(139),
	  /* template */
	  __webpack_require__(378),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(291)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(369),
	  /* scopeId */
	  "data-v-23c248ac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(297)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(153),
	  /* template */
	  __webpack_require__(375),
	  /* scopeId */
	  "data-v-44f4ac9e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', [_c('div', {
	    staticClass: "footer-logo-wrapper"
	  }, [_c('span', {
	    staticClass: "footer-left-logo-mengguo"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "footer-left-logo"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "Footer",
	    staticStyle: {
	      "margin": "-10px 0 10px 0",
	      "font-size": "14px"
	    }
	  }, [_c('div', {
	    staticClass: "foot_zhonggao"
	  }, [_c('ul', [_c('p', [_c('em', [_vm._v("健康游戏忠告")]), _vm._v("     "), _c('span', [_vm._v("抵制不良游戏")]), _vm._v("     "), _c('span', [_vm._v("拒绝盗版游戏")]), _vm._v("     "), _c('span', [_vm._v("注意自我保护")]), _vm._v("     "), _c('span', [_vm._v("谨防受骗上当")]), _vm._v("     "), _c('span', [_vm._v("适度游戏益脑")]), _vm._v("     "), _c('span', [_vm._v("沉迷游戏伤身")]), _vm._v("    "), _c('span', [_vm._v("合理安排时间")]), _vm._v("     "), _c('span', {
	    staticClass: "zg_lt"
	  }, [_vm._v("享受健康生活")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "foot_content"
	  }, [_c('ul', [_c('p', [_c('img', {
	    staticStyle: {
	      "margin-bottom": "-3px"
	    },
	    attrs: {
	      "src": __webpack_require__(334),
	      "height": "20",
	      "width": "20"
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402002156"
	    }
	  }, [_vm._v("沪公网安备31010402002156号")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Copyright © 2012 - 2020  上海萌果信息科技有限公司 版权所有 "), _c('br'), _vm._v("\n                    ICP证：沪ICP备12043106号     "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://beian.miit.gov.cn/"
	    }
	  }, [_vm._v("沪ICP备12043106号-10")]), _vm._v("    沪网文[2017] 2900-166号"), _c('br'), _vm._v("\n\n\n                    《"), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "jiazhang.html"
	    }
	  }, [_vm._v("家长监护工程")]), _vm._v("》《"), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "confirm.html"
	    }
	  }, [_vm._v("隐私政策")]), _vm._v("》\n                    "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://net.china.com.cn/"
	    }
	  }, [_vm._v("违法和不良信息举报中心")]), _vm._v("      "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://www.cyberpolice.cn/wfjb/"
	    }
	  }, [_vm._v("网络违法犯罪举报网站")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "liangzhao"
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/253AC0DA3EFF4776AD432958C98955CA"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "http://106.75.226.95/install_package/statics/images/mengguo/wenhuatb.png"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&entyId=20130521165953303"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "http://106.75.226.95/install_package/statics/images/mengguo/liangzhaoicon.gif",
	      "border": "0"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://www.shjbzx.cn"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(335),
	      "width": "94",
	      "height": "47"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "clear"
	  })])])])
	}]}

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "header-nav"
	  }, [_c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/home",
	      "onclick": "gaStat('导航', '首页')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('home')) + "\n        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/about",
	      "onclick": "gaStat('导航', '关于我们')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('about')) + "\n        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/game",
	      "onclick": "gaStat('导航', '游戏中心')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('center')) + "\n        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/business",
	      "onclick": "gaStat('导航', '商务合作')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('business')) + "\n        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/news",
	      "onclick": "gaStat('导航', '新闻资讯')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('news')) + "\n        ")])], 1), _vm._v(" "), (_vm.global.isTest) ? _c('button', {
	    staticClass: "btn",
	    staticStyle: {
	      "min-width": "80px"
	    },
	    on: {
	      "click": _vm.clearCache
	    }
	  }, [_vm._v("清除缓存")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "154px",
	      "height": "36px",
	      "display": "inline-block"
	    }
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header-logo"
	  }, [_c('div', {
	    staticClass: "eg-logo",
	    staticStyle: {
	      "text-decoration": "none",
	      "min-width": "460px"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "0 10px 10px 10px"
	    },
	    attrs: {
	      "src": __webpack_require__(337),
	      "width": "185"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "margin": "0 10px 10px 10px"
	    },
	    attrs: {
	      "src": __webpack_require__(333),
	      "width": "170"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "margin": "0 10px 0 0",
	      "width": "80px",
	      "height": "73px"
	    },
	    attrs: {
	      "src": __webpack_require__(336)
	    }
	  })])])
	}]}

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('view-header'), _vm._v(" "), _c('div', {
	    staticClass: "page-wrapper",
	    attrs: {
	      "id": "page-wrapper"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('view-footer')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.21195d959220a62701d3.js